import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import { TextBoxColors } from 'atoms/TextBox'
import {
  TextBoxBody4,
  TextBoxMaxLine1Footnote5Secondary,
} from 'atoms/TextBox/Templates'
import { TextBlock } from '../../TextBlock'

export interface ITextBlockDescriptionType3 extends ITextBlockProps {
  children?:
    | React.ReactElement<ITextBoxProps>
    | React.ReactElement<ITextBoxProps>[]
  title?: ITextBoxProps['title']
  description?: ITextBoxProps['title']
  colorDescription?: TextBoxColors
}

export const TextBlockDescriptionType3 = ({
  title,
  description,
  colorDescription = TextBoxColors.TEXT_ICON_CONSTANT_LIGHT,
  ...rest
}: ITextBlockDescriptionType3): JSX.Element => {
  return (
    <>
      {title && description && (
        <TextBlock {...rest}>
          <TextBoxMaxLine1Footnote5Secondary title={title} />
          <TextBoxBody4 color={colorDescription} preWrap>
            {description}
          </TextBoxBody4>
        </TextBlock>
      )}
    </>
  )
}
